/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import Pagination from 'components/atoms/pagination';
import Loader from 'components/atoms/loader';
import { productsServices } from 'store/modules/market_store/actions';
import ProductsModal from 'components/atoms/products_modal';

interface ProductsServicesProps {
  params: any;
}

const ProductsServices = (props: ProductsServicesProps) => {
  const { params } = props;
  const dispatch = useDispatch();
  const { products_services, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [products, setProducts] = useState<any>({});

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  useEffect(() => {
    dispatch(productsServices(params, currentPage));
  }, [currentPage, params]);

  const getProducts = (products: object) => {
    setProducts(products);
    setShowModal(true);
  };

  return (
    <div className="row mt-4">
      <div className="col-md-12">
        <div className="card overflow-auto">
          <div>
            <div className="pl-2 my-2 d-flex align-items-center">
              <i className="material-icons">shopping_cart</i>
              <b className="pl-1 mt-2">Produtos e Serviços</b>
            </div>
          </div>
          <ul className="list-group list-group-flush table-responsive">
            {request?.get_products?.loading ? (
              <Loader />
            ) : (
              <table className="table table-hover table-resultados">
                <thead style={{ backgroundColor: '#EBECEF' }}>
                  <tr>
                    <th scope="col">Item</th>
                    <th scope="col">Descrição</th>
                    <th scope="col">Vencedor</th>
                    <th scope="col">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {products_services?.products?.map((product) => {
                    let descricao_detalhado =
                      product?.item_descricao_detalhado != null &&
                      product?.item_descricao_detalhado.length > 360
                        ? `${product?.item_descricao_detalhado.substring(0, 360)}...`
                        : product?.item_descricao_detalhado;
                    if (descricao_detalhado == null)
                      descricao_detalhado =
                        product?.objeto.length > 360
                          ? `${product?.objeto.substring(0, 360)}...`
                          : product?.objeto;
                    const item_valor_unitario =
                      !isNaN(parseFloat(String(product?.item_valor_unitario))) &&
                      product?.item_valor_unitario > 0
                        ? product?.item_valor_unitario
                        : 0;
                    const item_valor_total =
                      !isNaN(parseFloat(String(product?.item_valor_total))) &&
                      product?.item_valor_total > 0
                        ? product?.item_valor_total
                        : 0;

                    return (
                      <tr
                        key={product?.id}
                        onClick={() => {
                          getProducts(product);
                        }}
                      >
                        <td>
                          {product?.item_descricao != null && product?.item_descricao.length > 105
                            ? `${product?.item_descricao.substring(0, 105)}...`
                            : product?.item_descricao}
                        </td>
                        <td>{descricao_detalhado}</td>
                        <td>{product?.fornecedor}</td>
                        <td>
                          {item_valor_unitario > 0
                            ? item_valor_unitario?.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })
                            : item_valor_total?.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </ul>
          <div className="border rounded-bottom border-top-0 d-print-none">
            <button
              type="button"
              key="btn-bidding-more-info"
              className="btn btn-sm btn-link m-0 w-100 mb-3"
              onClick={() => setBiddingInfoToggle(!BiddingInfoToggle)}
            >
              {BiddingInfoToggle ? 'Ver menos' : 'Ver mais'}
            </button>
            {BiddingInfoToggle && (
              <div className="row d-print-none">
                <div className="col-md-12 px-4 mb-5">
                  <Pagination
                    postsPerPage={10}
                    totalPosts={products_services?.total}
                    paginate={paginate}
                    currentPage={currentPage}
                    firstAndLastPage
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ProductsModal showModal={showModal} setShowModal={setShowModal} products={products} />
    </div>
  );
};

export default ProductsServices;
